<template>
	<div>
		<!-- support options dialog -->
		<v-dialog
			v-model="visible"
			persistent
			max-width="650px"
		>
			<v-card>
				<v-card-title class="justify-center grey--text text--darken-2">
					<h3>At your service!</h3>
					<v-btn icon absolute top right color="dark" @click="closeSupportOptionsDialog()">
						x
					</v-btn>
				</v-card-title>

				<v-card-subtitle class="grey--text text--darken-2">
					<h4>
						Mon - Fri 9:00AM - 7:00PM
					</h4>
				</v-card-subtitle>

				<v-card-text class="">
					<v-list two-line subheader>
						<!-- 1st support option -->
						<v-list-item class="py-2 justify-space-between" three-line @click="triggerSupportRequest()">
							<v-list-item-avatar class="">
								<v-icon large>
								mdi-headset
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="wrap-text grey--text text--darken-1">
									<h3>
										Request Support
									</h3>
								</v-list-item-title>
								<v-list-item-subtitle class="wrap-text font-weight-medium">
									Fill a quick form to request assistance from our support team.
								</v-list-item-subtitle>
							</v-list-item-content>
							<v-list-item-action class="">
								<v-icon large>
									mdi-chevron-right
								</v-icon>
							</v-list-item-action>
						</v-list-item>

						<!-- 2nd support option -->
						<v-list-item
							class="py-2 justify-space-between"
							two-line
							:href="currentUser && currentInstitution
										? 
									`https://wa.me/+917900087696?text=Hi! I'm ${currentUser.full_name} from ${currentInstitution.name}. I had an issue with the ERP...`
										:
									`https://wa.me/+917900087696`"
							target="_blank">
							<v-list-item-avatar>
								<v-icon large>
									mdi-whatsapp
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="wrap-text grey--text text--darken-1">
									<h3>
										WhatsApp Support
									</h3>
								</v-list-item-title>
								<v-list-item-subtitle class="wrap-text font-weight-medium">
									Get immediate support on WhatsApp Chat.
									<br>
									<v-icon>
										mdi-phone
									</v-icon>
									+91 7900087696
								</v-list-item-subtitle>
							</v-list-item-content>
							<v-list-item-action class="">
								<v-icon large>
								mdi-chevron-right
								</v-icon>
							</v-list-item-action>
						</v-list-item>

						<!-- 3rd support option -->
						<v-list-item v-if="currentUser && currentUser.is_admin" class="py-2 justify-space-between" two-line href="tel:+919082573219">
							<v-list-item-avatar>
								<v-icon large>
								mdi-phone-in-talk
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="wrap-text grey--text text--darken-1">
									<h3>
										Contact Support
									</h3>
								</v-list-item-title>
								<v-list-item-subtitle class="wrap-text font-weight-medium ">
									Get on a phone call with our support team.
									<br>
									<v-icon>
										mdi-phone
									</v-icon>
									+91 7900087696 | +91 9082573219
								</v-list-item-subtitle>
							</v-list-item-content>
							<v-list-item-action class="">
								<v-icon large>
									mdi-chevron-right
								</v-icon>
							</v-list-item-action>
						</v-list-item>
					</v-list>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- request support dialog -->
		<v-dialog
			persistent
			max-width="550px"
			v-model="requestSupportDialog"
		>
			<v-card>
				<v-card-title class="justify-center grey--text text--darken-2">
					<h3>Request Support!</h3>
					<v-btn icon absolute top right color="dark" @click="closeSupportRequestDialog()">
						x
					</v-btn>
				</v-card-title>
				
				<v-card-text>
					<v-form v-model="submitForm" @submit.prevent="submitSupportRequest()" ref="form">
						<v-container>
							<!-- row for name, phone -->
							<v-row>
								<v-col>
									<v-row>
										<v-col>
											<v-text-field
												v-model="supportRequestBody.full_name"
												label="Full Name *"
												dense
												:rules="[rules.required]"
												outlined
												class="rounded-input"
											></v-text-field>
										</v-col>
									</v-row>
								</v-col>
								<v-col>
									<v-row>
										<v-col>
											<v-text-field
												v-model="supportRequestBody.phone"
												label="Phone Number *"
												dense
												:rules="[rules.required, rules.numbersOnly, rules.phoneNumberLength]"
												outlined
												class="rounded-input"
											></v-text-field>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<!-- row for msg textarea -->
							<v-row>
								<v-col>
									<v-textarea
										label="Message *"
										outlined
										dense
										:rules="[rules.required]"
										class="rounded-input"
										v-model="supportRequestBody.message"
									>
										
									</v-textarea>
								</v-col>
							</v-row>
							<!-- submit btn row -->
							<v-row justify="center">
								<v-col>
									<v-btn
										type="submit"
										color="primary"
										v-model="submitForm"
										:disabled="!submitForm || isLoading"
									>
										Request Call
									</v-btn>
								</v-col>
							</v-row>
						</v-container>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- snackbar -->
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
			{{ snackbar.message }}
			<template v-slot:action="{ attrs }">
				<v-btn dark text v-bind="attrs" @click="snackbar.visible = false">
					Close
				</v-btn>
			</template>
		</v-snackbar>

	</div>
</template>

<script>
import api from "@api/index"
import { mapActions, mapGetters } from "vuex"
import endpoints from "@api/repository"
// import Helper from "@utils/misc"
import moment from "moment"

export default {
	name: 'SupportOptionsDialog',
	
	components: {},

	props: {
		"visible": {
			type: Boolean,
			default: true
		}
	},

	computed: {
		...mapGetters([
			"currentUser",
			"accessToken",
			"isLoading",
			"currentInstitution",
		]),

		apiEssentials() {
			return {
				accessToken: this.accessToken,
				setLoading: this.setLoading,
				handleErrorsFunction: this.handleApiErrors,
			};
		},
	},

	data() {
		return {
			moment: moment,
			snackbar: {
				visible: false,
				message: "",
				color: "dark",
			},

			rules: {
        required: (value) => !!value || "Required",
        numbersOnly: (v) => !v || !/[^0-9]/.test(v) || "Invalid",
        phoneNumberLength: (v) => !v || v?.length == 10 || "Should be 10 Digits",
      },

      requestSupportDialog: false,

			supportRequestBody: {
        id: null,
        full_name: null,
        phone: null,
        message: null,
      },

      submitForm: false,
		}
	},

	methods: {
		...mapActions(["toggleDrawer"]),
    ...mapActions(["setLoading"]),

    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        if (err.response.status == 409) {
          this.snackbar.message = err.response.data;
          this.snackbar.color = "error";
          this.snackbar.visible = true;
        }
      } else {
        this.snackbar.message = "Unable to process request";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },

		closeSupportOptionsDialog() {
      this.$emit('closeSupportOptionsDialog')
    },

    triggerSupportRequest() {
			if(this.currentUser) {
				this.supportRequestBody.id = this.currentUser.id
				this.supportRequestBody.full_name = this.currentUser.full_name
				this.supportRequestBody.phone = this.currentUser.phone
			}
			
			this.requestSupportDialog = true;
    },

    async submitSupportRequest() {
      var url = endpoints.requestSupport

      var response = await api.call(this.apiEssentials, url, api.Methods.POST, this.supportRequestBody)
      if(response) {
        this.snackbar.message = "Your Support Request has been raised. Our support team will get in touch with you soon"
        this.snackbar.visible = true
        this.snackbar.color = "success"
        this.closeSupportRequestDialog()
        this.closeSupportOptionsDialog()
      }
    },

    closeSupportRequestDialog() {
      this.requestSupportDialog = false
      this.supportRequestBody.message = null
      this.$refs.form.resetValidation()
    },
	},

	created() {

	}
}
</script>

<style lang="css">
.v-list-item__content {
  text-align: start;
}
</style>

<style scoped>
.v-list-item__content{
  max-width: 350px;
}
.wrap-text {
  -webkit-line-clamp: unset !important;
  white-space: normal;
}

</style>